<template>
  <section class="content-section">
    <a-step step="3" header="Gesundheit des Tieres" :leadin="leadin"/>

    <a-form class="info-form form" ref="petForm">
      <div class="container form__upper">
        <div v-if="leadin.errorMessage.message" class="afterSendError">{{ leadin.errorMessage.message }}</div>
        <br v-if="leadin.errorMessage.message">


          <div class="form__section upper-section">
            <div class="form__title">
              <h2>Bestehen bei {{ leadin.petname }} diagnostizierte Vorerkrankungen?</h2>
            </div>
            <div class="form__row">
              <div class="form__group form--small50">
                <div class="input-control">
                  <div class="wrapper">
                    <a-checkbox radio
                                v-model="treatmentBase"
                                label="ja" :value="true" :size="16" :rules="healthRules"
                                :disabled="!conditionCategories || leadin.isUDSelling"
                                v-on:check="healthElements.length === 0 ? openHealthModal() : null; pushDataLayer('tierdaten', 'gesundheit', 'ja')"/>
                  </div>
                </div>
              </div>
              <div class="form__group form--small50">
                <div class="input-control">
                  <div class="wrapper">
                    <a-checkbox radio
                                v-model="treatmentBase"
                                label="nein" :value="false"
                                :size="16" :rules="healthRules"
                                :disabled="!conditionCategories || leadin.isUDSelling"
                                v-on:check="pushDataLayer('tierdaten', 'gesundheit', 'nein')" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form__section question-list" v-if="treatmentBase" style="margin-top: 20px">
              <div class="treatment-headline">
                <div v-if="error.health" class="error">Sie müssen mindestens eine Vorerkrankung erfassen</div>
              </div>
              <div class="treatments">
                <div v-for="(healthElement, index) in healthElements" :key="index" class="treatment-box">
                  <div>
                    <div class="pr">
                      {{ healthElement.conditionCategory.name }}
                    </div>
                    <div class="pr">
                      <strong>{{ healthElement.preCondition.name }}</strong>
                    </div>
                  </div>
                  <div>
                     <div class="mt pr">
                      Status der Behandlung:<br>
                      {{ healthText.status[healthElement.status] }}
                    </div>
                    <div class="mt pr">
                      Häufigkeit der Behandlung:<br>
                      {{ healthText.occurrence[healthElement.occurrence] }}
                    </div>
                    <div class="mt pr" v-if="healthElement.description">
                      Beschwerden:<br>
                      {{ healthElement.description }}
                    </div>
                  </div>
                  <div class="treatment-edit" @click="openHealthModal(healthElement, index); pushDataLayer('ecommerce', 'editTreatment', healthElement.preCondition.description || healthElement.preCondition.name)">
                    <img src="@/assets/images/edit.svg"/>
                  </div>
                  <div class="treatment-trash" @click="deleteTreatment(index); pushDataLayer('ecommerce', 'deleteTreatment', healthElement.preCondition.description || healthElement.preCondition.name)">
                    <img src="@/assets/images/trash.svg"/>
                  </div>
               </div>
                <div v-if="conditionCategories" class="treatment-add"
                     @click="openHealthModal(); pushDataLayer('ecommerce', 'addTreatment', 'ja')">
                  + <template v-if="healthElements.length > 0">Weitere </template>Vorerkrankung hinzufügen
                </div>
              </div>
            </div>
          </div>

          <div class="form__section">
            <div class="form__title has-tooltip-icon">
              <h2>
                Hat {{ leadin.petname }} in den letzten 12 Monaten Symptome gezeigt, die seit mindestens 2 Wochen bestehen und mit denen {{leadin.petgender == '1' ? 'er' : 'sie'}} noch nicht beim Tierarzt war?
              </h2>
              <span class="tooltiptext">Symptome sind Anzeichen dafür, dass mit dem Tier etwas nicht in Ordnung ist oder eine Krankheit vorliegt.</span>
              <strong>Wenn ja, bitte wählen:</strong>
            </div>
            <div class="form__section question-list" v-if="symptoms">
              <div class="input-control" v-for="(symptom, index) in symptoms" :key="symptom.id">
                <a-checkbox v-model="symptomValues[index]"
                            :label="symptom.name"
                            v-on:check="symptomChange(symptom, $event); pushDataLayer('tierdaten', 'symptome_' + symptom.name, $event)"
                            :size="16"/>
              </div>
            </div>
          </div>
          <info-block>
            Alle getätigten Angaben sind sorgfältig, vollständig und richtig nach bestem Wissen zu beantworten. Wir weisen Sie daraufhin, dass eine Verletzung der vorvertraglichen Anzeigepflicht uns zu einem Rücktritt, zu einer Kündigung oder zu einer Vertragsänderung berechtigten. Bitte beachten Sie hierzu die <a :href="'//www.agila.de/images/pdf/AGILA-vorvertragliche-Infos-' + (leadin.country === 'Österreich' ? 'AT' : 'DE') + '-06-2024.pdf'" target="_blank">gesonderte Mitteilung zur vorvertraglichen Anzeigenpflicht nach {{ leadin.country === 'Österreich' ? '§ 16 – 22 VersVG' : '§ 19 Abs. 5 VVG'}}</a> über die Folgen eines Verstoßes gegen die gesetzlichen Anzeigepflichten.
          </info-block>
      </div>

      <div class="form__links">
        <div class="container">
          <div class="form__btn">
            <div class="form__btn-holder">
              <a-btn primary dark @click="submitBottom" class="btn btn--green">Weiter</a-btn>
            </div>
            <a v-if="!leadin.contract_id"
               v-on:click="$parent.back(2, 'persoenliche-daten'); pushDataLayer('tierdaten','go_back', 'persoenliche-daten')"
               class="form__back-link back-link"
            >
              <span class="back-link__icon icon-left-arrow"></span>Vorheriger Schritt
            </a>
          </div>
        </div>
      </div>
    </a-form>
  </section>
</template>

<script>
//const ga = window.ga
import {entryChannel, healthText} from "@/vars";
import dialog from "@/helpers/dialog";
import ModalHealth from "@/components/Modal/Health.vue";
import ModalHealthInfo from "@/components/Modal/HealthInfo.vue";
import InfoBlock from "@/components/InfoBlock.vue";
import {fetchProductRoute, sortResponse} from "@/helpers/productApi";

export default {
  components: {
    InfoBlock
  },
  model: {
    prop: 'leadin',
    event: 'leademit'
  },
  props: {
    registry: {
      type: Object,
      default() {
        return {}
      }
    },
    leadin: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data: () => ({
    error: {
      health: false
    },
    conditionCategories: null,
    symptoms: null,
    symptomValues: [],
    healthInfoShown: false,
    test: false,
    race: '1',
    petbirthday: '',
    petname: '',
    petgender: '1',
    petcolour: '',
    breed: '',
    breedList: [],
    isHP: false,
    noCat: false,
    hidden: true,
    health: '1',
    chronic: '0',
    respiratory: '0',
    hasNoRespiratory: false,
    finished: 0,
    file: '',
    fileInfo: {},
    isTK: false,
    isOP: false,
    healthElements: [],
    symptomElements: [],
    rules: {
      noClick: (v) => {return v?true:"Sie müssen Ja oder Nein anklicken"},
    },
    treatmentBase: null,
    healthCounter: 0,
    documentUploadText: "Dokument hochladen",
  }),
  watch: {
    leadin: {
      immediate: true,
      handler(to) {
        this.race = to.race

        this.petbirthday = to.petbirthday
        this.petname = to.petname
        this.petgender = to.petgender
        this.petcolour = to.petcolour
        this.breed = to.breed
        this.health = (to.health !== undefined) ? to.health : this.health;
        this.chronic = (to.chronic !== undefined) ? to.chronic : this.chronic
        this.respiratory = (to.respiratory !== undefined) ? to.respiratory : this.respiratory
        this.hidden = (to.hidden !== undefined) ? to.hidden : this.hidden
        this.file = to.file
        this.fileInfo = to.fileInfo
        this.treatmentBase = (to.treatmentBase !== undefined) ? to.treatmentBase : (to.healthElements && to.healthElements.length ? true : this.treatmentBase)
        this.healthElements = (to.healthElements !== undefined) ? to.healthElements : this.healthElements;
        this.symptomElements = (to.symptomElements !== undefined) ? to.symptomElements : this.symptomElements;
      }
    }

  },
  mounted: function () {
    fetchProductRoute(process.env.VUE_APP_API_ENDPOINT_PRODUCTS + 'condition-category?include=preConditions&filter[petTypeId]=' + this.race).then(response => {
      this.conditionCategories = sortResponse(response.data);
    });
    let breeds = this.registry.dogbreedsByName
    if (this.race == 2) {
      breeds = this.registry.catbreedsByName
    }
    fetchProductRoute(process.env.VUE_APP_API_ENDPOINT_PRODUCTS + 'symptom?filter[petTypeId]=' + this.race + '&filter[breedIdent]=' + breeds[this.breed].breed_id).then(response => {
      this.symptoms = response.data;
      this.symptoms.forEach(() => {
        this.symptomValues.push(false);
      });
      if (this.symptomElements.length) {
        this.symptomElements.forEach(symptomElement => {
          this.symptoms.forEach((symptom, index) => {
            if (symptomElement.id === symptom.id) {
              this.symptomValues[index] = true;
            }
          })
        });
      }
    });

    const brokerList = []//["1195114", "1606686", "1616388", "1656095", "999", "99901", "1595114"]

    if ((this.leadin.productActive == 1 || this.leadin.productActive == 2 || this.leadin.productActive == 4) && !brokerList.includes(this.leadin.brokerID) && this.leadin.tm == false) {


      this.isTK = true;

      this.$watch('finished', () => {
        this.finished = 1;
        //this.documentUploadText = 'Datei wurde hochgeladen'
      })
    }

    if ((this.leadin.productActive == 12 || this.leadin.productActive == 11 || this.leadin.productActive == 3) && !brokerList.includes(this.leadin.brokerID) && this.leadin.tm == false) {


      this.isOP = true;

      this.$watch('finished', () => {
        this.finished = 1;
        //this.documentUploadText = 'Datei wurde hochgeladen'
      })


    }

    this.setRace(this.race)

    if (this.leadin.petbirthday == undefined) {
      this.leadin.petbirthday = new Date()
      this.leadin.petbirthday.setDate(this.leadin.petbirthday.getDate() - 56)
    }

    this.petbirthday = this.leadin.petbirthday
    this.petname = this.leadin.petname
    this.breed = this.leadin.breed
    this.race = this.leadin.race
    this.petgender = this.leadin.petgender
    this.petcolour = this.leadin.petcolour
    this.race = this.leadin.race
    if (this.leadin.healthElements) {
      this.healthElements = this.leadin.healthElements
    }
    if (this.leadin.symptomElements) {
      this.symptomElements = this.leadin.symptomElements
    }

    if (this.registry.productByID[this.leadin.productActive].coverage_DE !== '') {
      this.isHP = true
    }

    if (this.leadin.productActive == 2) {
      this.noCat = true
    }

    if (this.race == 2 && (this.leadin.productSet == 6 || this.leadin.productSet == 5 || this.leadin.productSet == 7)) {
      this.race = "1"
      this.setRace('1')

    }
  },
  computed: {
    healthText() {
      return healthText
    },
    healthRules () {
      const rules = []
      if (this.treatmentBase === null && !this.leadin.isUDSelling) {
        rules.push(this.rules.noClick)
      }
      return rules
    },
    yeartype() {
      return (this.registry.productByID[this.leadin.productActive].abbreviation.substring(0, 2) == 'HP') ? 'hppet' : 'pet';
    },
  },
  methods: {
    symptomChange(symptom, value) {
      if (value) {
        this.symptomElements.push(symptom);
      } else {
        this.symptomElements.splice(this.symptomElements.findIndex(res => res.id === symptom.id), 1)
      }
    },
    addHealthElement(element) {
      this.healthElements.push(element);
    },
    editHealthElement(element, index) {
      this.$set(this.healthElements, index, element);
    },
    openHealthModal(preSelection = null, index = null) {
      dialog.component(ModalHealth, {
        conditionCategories: this.conditionCategories,
        registry: this.registry,
        leadin: this.leadin,
        preSelection: preSelection
      }).then(result => {
        if (result) {
          if (preSelection) {
            this.editHealthElement(result, index);
          } else {
            this.addHealthElement(result);
          }
          try {
            result.conditionCategory = {
              description: result.conditionCategory.description,
              id: result.conditionCategory.id,
              name: result.conditionCategory.name
            }
            this.pushDataLayer('tierdaten', preSelection ? 'editTreatment' : 'saveTreatment', result);
          } catch (e) {
            console.error(e);
          }
          this.error.health = false;
        }
      })
    },
    deleteTreatment(index) {
      this.healthElements.splice(index, 1);
    },
    addOP() {
      this.healthCounter++
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;

      this.createImage(files[0]);
    },
    createImage(file) {
      this.documentUploadText = 'Datei wird geladen'
      //var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);

      this.documentUploadText = file.name
      this.fileInfo = file.type;
      reader.onload = () => {
        this.finished = 1
        this.file = reader.result
      };
    },
    setRace(e) {
      var breeds = this.registry.dogList
      var colour = this.registry.dogColourList

      if (e == '2') {
        breeds = this.registry.catList
        colour = this.registry.catColourList
      }

      this.breed = ''
      this.petcolour = ''
      this.registry.breedList = breeds
      this.registry.colourList = colour
    },

    generateTrackingList(baseObject) {
      const itemList = [];

      if (baseObject.base) {
        Object.keys(baseObject).forEach(item => {
          if (item !== 'base' && baseObject[item]) {
            itemList.push(
                item !== 'beschreibung'
                    ? item.charAt(0).toUpperCase() + item.slice(1)
                    : baseObject.beschreibung
            );
          }
        });
      }
      return itemList;
    },

    checkHealthElementsError() {
      if (this.treatmentBase && this.healthElements.length === 0) {
        this.error.health = true;
        return false;
      } else {
        this.error.health = false;
        return true;
      }
    },

    submitBottom() {
      if (this.$refs.petForm.validate() && this.checkHealthElementsError()) {
        if ((this.treatmentBase || this.symptomElements.length) && !this.healthInfoShown) {
          dialog.component(ModalHealthInfo, {
            healthElements: this.healthElements,
            symptomElements: this.symptomElements
          }).then(result => {
            if (result) {
              this.healthInfoShown = true;
              this.submitBottom();
            }
          })
        } else {
          let matrix = this.getMatrix(this, this.registry, this.leadin.productActive);
          let seconds = this.calcAgeInSeconds(this.petbirthday)

          let productPrice = parseFloat(this.calcPrice(matrix, seconds).toString().replace(/,/, '.'))

          this.leadin.race = this.race
          this.leadin.petbirthday = this.petbirthday
          this.leadin.petname = this.petname
          this.leadin.petcolour = this.petcolour
          this.leadin.petgender = this.petgender
          this.leadin.breed = this.breed
          this.leadin.hidden = this.hidden
          this.leadin.healthElements = this.healthElements
          this.leadin.symptomElements = this.symptomElements
          this.leadin.chronic = this.chronic
          this.leadin.respiratory = this.respiratory
          this.leadin.file = this.file
          this.leadin.fileInfo = this.fileInfo
          this.leadin.treatmentBase = this.treatmentBase
          this.leadin.productPrice = productPrice
          this.$emit('leademit', this.leadin)

          // Tracking Start
          if (
              this.registry.cc &&
              (this.registry.cc.includes("gat") ||
                  this.registry.cc.includes("all") ||
                  this.registry.cc.includes("marketing"))
          ) {
            try {
              let symptoms_list = [];
              if (this.symptomElements && this.symptomElements.length) {
                this.symptomElements.forEach(symptom => {
                  symptoms_list.push({
                    id: symptom.id,
                    name: symptom.name,
                  })
                })
              }
              let treatment_list = [];
              if (this.treatmentBase) {
                this.healthElements.forEach(treatment => {
                  treatment_list.push({
                    id: treatment.preCondition.id,
                    name: treatment.preCondition.name,
                    category: treatment.conditionCategory.name,
                    description: treatment.description,
                    status: treatment.status,
                    occurrence: treatment.occurrence
                  })
                })
              }

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ecommerce: null})
              window.dataLayer.push({
                event: "add_health_info",
                ecommerce: {
                  details: {
                    currency: "EUR",
                    value: this.leadin.productPrice,
                    antragsstrecke_ueber: entryChannel,
                    customer: {
                      city: this.leadin.city,
                      country: this.leadin.country,
                      mail: this.leadin.email,
                      telefon: this.leadin.phone
                    },
                    pet: {
                      tierart: this.race == '1' ? "Hund" : "Katze",
                      rasse: this.breed,
                      alter: this.calculateAge(this.petbirthday),
                      geschlecht: this.petgender,
                      fellfarbe: this.petcolour,
                      rufname: this.petname,
                      symptoms_list: symptoms_list,
                      treatment: this.treatmentBase ? "ja" : "nein",
                      treatment_list: treatment_list,
                    }
                  },
                  items: this.getTrackingProductItems()
                }
              });
            } catch (e) {
              console.error(e);
            }
          }
          // Tracking End

          this.$parent.advance('advanceHealth', true)

          return true;
        }
      } else {
        document.getElementById('jumppoint').scrollIntoView();
      }
    }
  }
}


/*
- kucken wie ausgewählt markiert wird
- kucken, wie show geht

- v-bind:class="{classname:bool,classname2:bool2}""


*/

</script>
<style scoped>
.preDamage .checkbox .text {
  width: 80% !important;
  padding-left: 10px;
  margin-left: 15px;
}

.form .preDamage .control {
  padding: 20px;
}

.more-margin {
  margin-bottom: 35px;
}

@media (max-width: 599px) {
  .form__group.form--large.form--unlarge {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .has-tooltip-icon h2 {
    display: inline-block
  }
}

.custom-file-upload {

}

input[type="file"] {
  display: none;
}

</style>
<style>
.hidefield .input-control .wrapper, .hidefield .input-control .label {
  display: none !important;
}

.hidefield .input-control .error {
  position: relative;
  top: -13px;

}

.form__section.upper-section {
  margin-bottom: 36px;
}

.form__section.question-list {
  margin-bottom: 20px !important;
}

.form__section.question-list .form__title {
  margin-bottom: 10px;
}

.form__section.question-list .form__title .error {
  margin: 10px 0 0;
}

.form__section.question-list .label {
  margin-left: 10px;
}

.form__section.question-list .input-control.type-multiline {
  margin-top: 10px !important;
  font-size: 12px;
}

.form__section.question-list .input-control.type-multiline .label {
  top: 5px;
  left: 0px;
  font-size: 12px;
}

.form__section.question-list .input-control.type-multiline + .type-pattern {
  margin-top: 20px !important;
}

.input-control .control.type-pattern {
  width: 46%;
  margin-left: 20px;
}

.treatment-headline {
  margin-bottom: 18px;
}
.treatment-headline .error {
  margin: 10px 0 0;
}

.treatments {
  display: grid;
  grid-template-columns: 100%;
  @media (min-width: 500px) {
    grid-template-columns: calc(50% - 9px) calc(50% - 9px);
  }
  @media (min-width: 1000px) {
    grid-template-columns: calc(33% - 6px) calc(33% - 6px) calc(33% - 6px);
  }
  gap: 18px;
}

.treatment-box {
  border-radius: 8px;
  background-color: #F1F8FF;
  padding: 12px;
  display: flex;
  flex-direction: column;
  position: relative;
  color: #3b3b3b;
}

.treatment-box .pr {
  padding-right: 30px;
}

.treatment-box .mt {
  margin-top: 10px;
}

.treatment-edit {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  border-radius: 15px;

  img {
    width: 30px;
  }

  &:hover {
    background: #ffffff;
  }
}

.treatment-trash {
  position: absolute;
  top: 50px;
  right: 10px;
  cursor: pointer;
  border-radius: 15px;

  img {
    width: 30px;
  }

  &:hover {
    background: #ffffff;
  }
}

.treatment-add {
  padding: 10px 0;
  text-decoration: underline;
  color: #014e9e;
  cursor: pointer;
}

.form__section.question-list .input-control.type-multiline .input textarea {
  height: 60px !important;
  font-size: 12px !important;
  padding-top: 15px !important;
  line-height: 15px !important;
}

.form__section.question-list .input-control.type-multiline {
  font-size: 14px !important;
  top: 9px;
  left: 0px;
  color: #3b3b3b;

}

.form__title.less-margin {
  margin-bottom: -10px;
}

.half-control:after {
  content: "";
  display: table;
  clear: both;
}

.half-control .control {
  width: 29.8%;
  display: inline-box;
  float: left;
}

@media (max-width: 1439px) {
  .half-control .checkbox.control .text {
    margin-left: 0 !important
  }
}

@media (max-width: 1023px) {
  .half-control .control {
    width: 48%;
  }
}

@media (max-width: 521px) {
  .half-control .control {
    width: 100%;
  }
}

.form__section.question-list .input-control.half-control .type-pattern .label {
  font-size: 12px !important;
  top: 5px;
  left: 0px;
  color: #3b3b3b;
}

.form__section.question-list .input-control.half-control .type-pattern.focused .label {
  color: #004e9e;
}

.form__section.question-list .input-control.half-control .input input {
  height: 25px !important;
  font-size: 12px !important;
  padding-top: 12px !important;
  line-height: 12px !important;
}

.form__section.question-list .input-control.half-control .wrapper {
  padding-top: 13px !important;
  margin-bottom: 2px !important;
}

.form__section.question-list .input-control.focused .label, .form__section.question-list .input-control.filled .label {
  transform: translate(2px, -5px) scale(0.8, 0.8) !important;
}
</style>
